/**
 * Newsletter Widget - Optimized JavaScript
 * Features: AJAX submission, KVKK modal, toast notifications
 * No page reload, accessible, performant
 */

(function () {
  "use strict";

  // ============================================
  // CONFIGURATION
  // ============================================
  const CONFIG = {
    submitUrl: "/Newsletter/Subscribe",
    toastDuration: 5000,
    emailRegex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    selectors: {
      form: "[data-newsletter-form]",
    },
    sources: {
      "contact-section": "Contact",
      homepage: "Homepage",
      blog: "Blog",
      courses: "Courses",
      footer: "Footer",
      sidebar: "Sidebar",
      "content-bottom": "ContentBottom",
      popup: "Popup",
      "blog-detail": "BlogDetail",
      "course-detail": "CourseDetail",
      "coming-soon": "ComingSoon",
    },
  };

  // ============================================
  // CONSENT MODAL MANAGER
  // ============================================
  const ConsentModal = {
    activeModal: null,
    pendingData: null,

    create(email, formId) {
      const modalId = `newsletter-consent-modal-${formId}`;
      let modal = document.getElementById(modalId);

      if (!modal) {
        modal = this.buildModal(modalId, email);
        document.body.appendChild(modal);
      } else {
        this.updateEmail(modal, email);
      }

      this.activeModal = modal;
      this.setupEventListeners(modal);
      return modal;
    },

    buildModal(modalId, email) {
      const modal = document.createElement("div");
      modal.id = modalId;
      // Ana modal container sınıfları
      modal.className =
        "fixed inset-0 z-[9999] hidden items-center justify-center p-4 bg-black/60 backdrop-blur-sm opacity-0 transition-opacity duration-300";

      modal.innerHTML = `
            <div class="bg-[var(--base-content)] rounded-2xl w-full max-w-lg max-h-[90vh] flex flex-col shadow-[var(--box-shadow)] border border-[var(--border-color)] overflow-hidden transform scale-95 transition-transform duration-300">
                <div class="p-5 border-b border-[var(--border-color)] flex justify-between items-center bg-[var(--base-section)]">
                    <div class="flex items-center gap-2 text-[var(--theme-primary)]">
                        <i class="bx bxs-shield-quarter text-2xl"></i>
                        <h3 class="text-xl font-bold text-[var(--text-base)]">Abonelik Onayı</h3>
                    </div>
                    <button type="button" class="text-[var(--text-four)] hover:text-[var(--text-second)] transition-colors" data-consent-close>
                        <i class="bx bx-x text-3xl"></i>
                    </button>
                </div>

                <div class="p-6 overflow-y-auto custom-scrollbar bg-[var(--base-content)] space-y-6">
                    <div class="bg-gradient-to-br from-[var(--theme-primary)] to-[var(--theme-bg-hover)] p-5 rounded-2xl flex items-center gap-4 text-white shadow-lg shadow-[var(--theme-shadow)]">
                        <div class="w-12 h-12 bg-white/20 backdrop-blur-md rounded-xl flex items-center justify-center text-2xl">
                            <i class="bx bx-mail-send"></i>
                        </div>
                        <div class="overflow-hidden">
                            <p class="text-[10px] opacity-80 font-bold uppercase tracking-wider leading-none mb-1">Abone Olacak E-Posta</p>
                            <p class="consent-email-display font-semibold truncate text-lg">${this.escapeHtml(email)}</p>
                        </div>
                    </div>

                    <div class="pl-4 border-l-2 border-[var(--base-hover-bg)] space-y-4">
                        <h4 class="font-bold text-[var(--text-base)]">Bilgilendirme</h4>
                        <ul class="space-y-3">
                            <li class="flex items-start gap-2 text-sm text-[var(--text-body)]">
                                <i class="bx bx-check-circle text-[var(--theme-primary)] mt-0.5"></i>
                                <span><strong>Hizmet:</strong> Haftalık bülten ve özel fırsatlar.</span>
                            </li>
                            <li class="flex items-start gap-2 text-sm text-[var(--text-body)]">
                                <i class="bx bx-check-circle text-[var(--theme-primary)] mt-0.5"></i>
                                <span><strong>Veri:</strong> E-posta adresiniz güvenle saklanır.</span>
                            </li>
                        </ul>
                    </div>

                    <label class="group flex items-start gap-3 p-4 rounded-xl border border-[var(--border-color-trans)] bg-[var(--base-section)] cursor-pointer hover:border-[var(--theme-primary)] transition-all">
                        <input type="checkbox" class="consent-checkbox mt-1 w-5 h-5 accent-[var(--theme-primary)] rounded cursor-pointer">
                        <span class="text-xs sm:text-sm text-[var(--text-body)] leading-relaxed group-hover:text-[var(--text-base)]">
                            <a href="/yasal/kvkk" target="_blank" class="text-[var(--theme-primary)] underline font-medium hover:opacity-80">KVKK Aydınlatma Metni</a>'ni okudum, ticari ileti gönderilmesini onaylıyorum.
                        </span>
                    </label>
                </div>

                <div class="p-5 border-t border-[var(--border-color)] bg-[var(--base-section)] flex items-center justify-end gap-3">
                    <button type="button" class="px-6 py-2 rounded-xl text-[var(--text-second)] hover:bg-[var(--base-hover-bg)] transition-all font-medium" data-consent-close>
                        İptal
                    </button>
                    <button type="button" class="consent-confirm-btn bg-[var(--theme-bg)] opacity-40 cursor-not-allowed text-white px-8 py-2 rounded-xl transition-all font-semibold shadow-none" disabled>
                        Onayla ve Kaydol
                    </button>
                </div>
            </div>
        `;
      return modal;
    },

    updateEmail(modal, email) {
      const emailDisplay = modal.querySelector(".consent-email-display");
      if (emailDisplay) emailDisplay.textContent = email;
    },

    setupEventListeners(modal) {
      const checkbox = modal.querySelector(".consent-checkbox");
      const confirmBtn = modal.querySelector(".consent-confirm-btn");
      const closeButtons = modal.querySelectorAll("[data-consent-close]");
      const content = modal.querySelector("div:first-child");

      checkbox.addEventListener("change", () => {
        const isChecked = checkbox.checked;
        confirmBtn.disabled = !isChecked;
        confirmBtn.style.opacity = isChecked ? "1" : "0.4";
        confirmBtn.classList.toggle("cursor-not-allowed", !isChecked);
        confirmBtn.classList.toggle("hover:bg-[var(--theme-bg-hover)]", isChecked);
        confirmBtn.classList.toggle("shadow-lg", isChecked);
        confirmBtn.classList.toggle("shadow-[var(--theme-shadow)]", isChecked);
      });

      confirmBtn.onclick = () => {
        if (this.pendingData && !confirmBtn.disabled) {
          this.close();
          this.pendingData.callback();
        }
      };

      closeButtons.forEach((btn) => (btn.onclick = () => this.close()));
    },

    open(email, formId, callback) {
      this.pendingData = { email, formId, callback };
      const modal = this.create(email, formId);

      modal.classList.remove("hidden");
      modal.classList.add("flex");

      setTimeout(() => {
        modal.classList.add("opacity-100");
        modal.querySelector("div").classList.remove("scale-95");
        modal.querySelector("div").classList.add("scale-100");
      }, 10);

      document.body.style.overflow = "hidden";
    },

    close() {
      if (this.activeModal) {
        this.activeModal.classList.remove("opacity-100");
        this.activeModal.querySelector("div").classList.add("scale-95");

        setTimeout(() => {
          this.activeModal.classList.add("hidden");
          this.activeModal.classList.remove("flex");
          document.body.style.overflow = "";
          this.activeModal = null;
        }, 300);
      }
    },

    escapeHtml(text) {
      const div = document.createElement("div");
      div.textContent = text;
      return div.innerHTML;
    },
  };

  // ============================================
  // FORM HANDLER
  // ============================================
  const NewsletterForm = {
    forms: new Map(),
    // Spam engelleme ayarları
    throttleConfig: {
      seconds: 60,
      storageKey: "_newsletter_last_submit",
    },

    init() {
      const forms = document.querySelectorAll(CONFIG.selectors.form);
      forms.forEach((form) => this.register(form));
      this.observeDynamicForms();
    },

    register(form) {
      if (this.forms.has(form)) return;
      const formId = this.generateId();
      form.dataset.newsletterFormId = formId;
      this.forms.set(form, { id: formId });
      form.addEventListener("submit", (e) => this.handleSubmit(e, form));
    },

    // Yeni: Zaman aşımı kontrolü
    isThrottled() {
      const lastSubmit = localStorage.getItem(this.throttleConfig.storageKey);
      if (lastSubmit) {
        const diff = (Date.now() - parseInt(lastSubmit)) / 1000;
        if (diff < this.throttleConfig.seconds) {
          const remaining = Math.ceil(this.throttleConfig.seconds - diff);
          Toast.info("Lütfen Bekleyin", `Yeni bir istek göndermeden önce ${remaining} saniye beklemelisiniz.`);
          return true;
        }
      }
      return false;
    },

    handleSubmit(e, form) {
      e.preventDefault();

      // Spam kontrolü
      if (this.isThrottled()) return;

      const emailInput = form.querySelector('input[type="email"], input[name="email"]');
      if (!emailInput) {
        Toast.error("Teknik Sorun", "E-posta alanı sunucu tarafından bulunamadı.");
        return;
      }

      const email = emailInput.value.trim();
      const rawSource = form.dataset.source || form.dataset.newsletterSource || "unknown";
      const source = this.mapSource(rawSource);

      if (!email) {
        Toast.info("Eksik Bilgi", "İşleme devam edebilmek için lütfen e-posta adresinizi girin.");
        emailInput.focus();
        return;
      }

      if (!CONFIG.emailRegex.test(email)) {
        Toast.info("Geçersiz Format", "Lütfen geçerli bir e-posta adresi girdiğinizden emin olun.");
        emailInput.focus();
        return;
      }

      const formId = form.dataset.newsletterFormId;

      if (source === "ComingSoon") {
        // Erken kayıtta onay popup'ı olmaksızın doğrudan kayıt yapıyoruz
        this.submit(form, email, source);
      } else {
        ConsentModal.open(email, formId, () => {
          this.submit(form, email, source);
        });
      }
    },

    async submit(form, email, source) {
      this.setLoading(form, true);

      try {
        const response = await fetch(CONFIG.submitUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ email, source }),
        });

        const data = await response.json();

        if (response.ok && data.success) {
          // BAŞARILI DURUMDA: Zaman damgasını kaydet
          localStorage.setItem(this.throttleConfig.storageKey, Date.now().toString());

          if (data.data?.requiresVerification) {
            Toast.success(
              "Neredeyse Tamam! 📧",
              "Aboneliğinizi aktifleştirmek için e-posta adresinize bir onay bağlantısı gönderdik. Lütfen kutunuzu kontrol edin.",
            );

            setTimeout(() => {
              Toast.info(
                "Küçük Bir Not",
                "E-posta kutunuzda göremiyorsanız spam/gereksiz klasörünü kontrol etmeyi unutmayın.",
              );
            }, 2000);
          } else {
            Toast.success("Başarılı!", data.message || "Bülten aboneliğiniz tamamlandı.");
          }

          const emailInput = form.querySelector('input[type="email"], input[name="email"]');
          if (emailInput) emailInput.value = "";

          this.trackEvent("newsletter_subscribe", { source });
        } else {
          // Servisten gelen hata mesajı (Zaten kayıtlı vb.)
          Toast.error("İşlem Başarısız", data.message || "Abonelik işleminiz şu anda gerçekleştirilemiyor.");
        }
      } catch (error) {
        console.error("Newsletter error:", error);
        Toast.error("Bağlantı Hatası", "Sunucu ile iletişim kurulamadı. Lütfen daha sonra tekrar deneyin.");
      } finally {
        this.setLoading(form, false);
      }
    },

    setLoading(form, isLoading) {
      form.classList.toggle("loading", isLoading);
      const submitBtn = form.querySelector('button[type="submit"]');
      const emailInput = form.querySelector('input[type="email"], input[name="email"]');

      if (submitBtn) {
        submitBtn.disabled = isLoading;
        const loadingText = submitBtn.querySelector(".submit-loading");
        const normalText = submitBtn.querySelector(".submit-text");

        if (loadingText && normalText) {
          loadingText.style.display = isLoading ? "inline-flex" : "none";
          normalText.style.display = isLoading ? "none" : "inline";
        } else {
          if (isLoading) {
            submitBtn.dataset.originalText = submitBtn.textContent;
            submitBtn.innerHTML =
              '<span class="submit-loading" style="animation: spin 1s linear infinite;">⏳</span> İşleniyor...';
          } else if (submitBtn.dataset.originalText) {
            submitBtn.textContent = submitBtn.dataset.originalText;
          }
        }
      }

      if (emailInput) {
        emailInput.disabled = isLoading;
      }
    },

    trackEvent(eventName, data) {
      if (typeof gtag !== "undefined") gtag("event", eventName, data);
      if (typeof fbq !== "undefined") fbq("track", "Lead", data);
      if (typeof window.analytics !== "undefined") window.analytics.track(eventName, data);
    },

    observeDynamicForms() {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              if (node.matches && node.matches(CONFIG.selectors.form)) {
                this.register(node);
              }
              const forms = node.querySelectorAll && node.querySelectorAll(CONFIG.selectors.form);
              if (forms) {
                forms.forEach((form) => this.register(form));
              }
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    },

    generateId() {
      return "nf-" + Math.random().toString(36).substr(2, 9);
    },

    mapSource(source) {
      return CONFIG.sources[source] || "Other";
    },
  };

  // ============================================
  // INITIALIZATION
  // ============================================
  function init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        NewsletterForm.init();
      });
    } else {
      NewsletterForm.init();
    }
  }

  // Start
  init();

  // Expose API for external use
  window.Newsletter = {
    toast: Toast,
    forms: NewsletterForm,
  };
})();
